var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#FFE4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9998 12.5996C35.1044 12.5996 35.9998 13.495 35.9998 14.5996V19.7996H19.7998V14.5996C19.7998 13.495 20.6952 12.5996 21.7998 12.5996H33.9998Z",
    fill: "#F44067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6251 32.3994H34.1996V32.8587C34.1996 39.4339 34.1996 46.0087 34.1996 52.5832C34.1954 56.4886 31.2948 59.4989 27.6592 59.3969C24.4382 59.3067 21.6427 56.3695 21.6225 52.9126C21.5813 46.145 21.6082 39.3728 21.6082 32.6033C21.6057 32.5456 21.62 32.4878 21.6251 32.3994Z",
    fill: "#F44067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1996 23.3994V28.7994H21.5996V23.3994H34.1996Z",
    fill: "#F44067"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7197 32.3994C49.9153 35.5685 52.1172 38.6263 53.5556 42.1307C55.2405 46.2414 51.895 50.5902 47.448 50.3929C43.041 50.1977 40.4579 45.9398 41.7194 42.6684C42.2541 41.2702 42.894 39.9119 43.6339 38.6048C44.5658 36.9742 45.6483 35.4244 46.6782 33.847C46.9857 33.3808 47.3332 32.9351 47.7197 32.3994Z",
    fill: "#F44067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.d93c68cf802e72645f46706e0421b77c.svg";
export { ForwardRef as ReactComponent };